"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const intl_1 = require("@kyruus/intl");
const button_1 = __importDefault(require("@kyruus/button"));
const styles_1 = require("./styles");
const messages_1 = __importDefault(require("../../lib/messages"));
const api_1 = require("../../lib/api");
const load_script_1 = __importDefault(require("load-script"));
const styles_2 = require("./styles");
function RecaptchaModal({ onCancel, onVerified, onError, siteKey, customerCode, productName, apiBaseURL, intl }) {
    const [grecaptchaLoaded, setGrecaptchaLoaded] = (0, react_1.useState)(false);
    const containerRef = (0, react_1.useRef)();
    const onGrecaptchaReady = (0, react_1.useCallback)(() => {
        setGrecaptchaLoaded(true);
        window.grecaptcha.render(containerRef.current, {
            sitekey: siteKey,
            callback: (response) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const data = yield new api_1.Api({
                        customerCode,
                        productName,
                        apiBaseURL
                    }).postCaptchaResponseToken(response);
                    if (data.verified) {
                        onVerified(data.verified);
                    }
                    else {
                        onError();
                    }
                }
                catch (e) {
                    onError(e);
                }
            })
        });
        // skip dependency checks to enforce this hook running only once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, react_1.useEffect)(() => {
        if (typeof window.grecaptcha === 'object') {
            window.grecaptcha.ready(onGrecaptchaReady);
        }
        else {
            (0, load_script_1.default)('https://www.google.com/recaptcha/api.js?render=explicit', (err) => {
                if (!err) {
                    window.grecaptcha.ready(onGrecaptchaReady);
                }
            });
        }
    }, [onGrecaptchaReady]);
    const modalBody = grecaptchaLoaded ? (react_1.default.createElement("div", { "data-testid": "RecaptchaLoaded", ref: containerRef })) : (react_1.default.createElement(styles_2.LoadingContainer, { "data-testid": "LoadingGrecaptcha" },
        react_1.default.createElement(styles_2.LoadingCell, null)));
    return (react_1.default.createElement(styles_1.Modal, { "data-testid": "Recaptcha", title: intl.formatMessage(messages_1.default.interruptionapology), subtitle: intl.formatMessage(messages_1.default.notrobot), open: true, useHeaderBorder: false, maxWidth: "md", body: modalBody, onClose: onCancel, primaryButton: react_1.default.createElement(button_1.default, { onClick: onCancel },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.cancel))) }));
}
RecaptchaModal.propTypes = {
    onCancel: prop_types_1.default.func.isRequired,
    /** callback for when captcha response is verified correctly against the API */
    onVerified: prop_types_1.default.func.isRequired,
    /** callback when recaptcha validation encounters an error from the API */
    onError: prop_types_1.default.func.isRequired,
    siteKey: prop_types_1.default.string.isRequired,
    customerCode: prop_types_1.default.string.isRequired,
    productName: prop_types_1.default.string.isRequired,
    apiBaseURL: prop_types_1.default.string.isRequired,
    // provided via `injectIntl`
    intl: prop_types_1.default.object.isRequired
};
exports.default = (0, intl_1.injectIntl)(RecaptchaModal);
//# sourceMappingURL=RecaptchaModal.js.map